import { Footer } from '../components/Footer';
import { Toolbar } from '../components/Toolbar';
import { Button, LinkButton } from '../components/primitives';
import { Sidebar } from '../components/sidebar/Sidebar';
import { testId } from '../utils';
import { Trans } from '@rpi/i18n';
import { QueryErrorResetBoundary } from '@tanstack/react-query';
import clsx from 'clsx';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useLocation, Outlet } from 'react-router-dom';

export const UserLayout: React.FC = () => {
  const [mobileSidebarOpen, toggleMobileSidebar] = React.useReducer(
    (state) => !state,
    false,
  );
  const location = useLocation();

  React.useEffect(() => {
    toggleMobileSidebar();
  }, [location]);

  return (
    <div className="w-full h-screen flex flex-col relative">
      <Toolbar toggleSidebar={toggleMobileSidebar} />
      <div className="flex-grow flex flex-row w-full">
        <Sidebar
          className={clsx('fixed md:relative right-0', {
            'inline-block': mobileSidebarOpen,
            'hidden md:inline-block': !mobileSidebarOpen,
          })}
        />
        <div className="w-full flex flex-col justify-between">
          <div className="px-10 py-10">
            <QueryErrorResetBoundary>
              {({ reset }) => (
                <ErrorBoundary
                  onReset={reset}
                  fallbackRender={({ resetErrorBoundary }) => (
                    <div {...testId('error-boundary')}>
                      <Trans
                        i18nKey="errors.generic"
                        components={{
                          'try-again': (
                            <LinkButton
                              {...testId('error-boundary', 'reset')}
                              onClick={() => resetErrorBoundary()}
                            />
                          ),
                        }}
                      />
                    </div>
                  )}
                >
                  <Outlet />
                </ErrorBoundary>
              )}
            </QueryErrorResetBoundary>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};
